import React, { useState } from "react";
import {
  Title,
  Select,
  GoBack,
  Button,
  TextArea,
  MyMessage,
  PhoneInput,
  InputField,
  DashboardIntro,
  MyActionButton,
  MyButton,
} from "../../home/component/Component";
import { codeOk } from "../../../middlewares/index";
import { BreadCrumbComponent } from "../../../middlewares/breadCrumb/BreadCrumbComponent";
import { useDoSeeDataContext } from "../../../context/doSeeData/DoSeeDataContext";
import { getOneHotel } from "../../../middlewares/sysNavigation/SysNavigation";
import { FOLDERS, image_kit_folder } from "../utils/Utils";
import { defaultImage } from "../../../middlewares/libraries/imageKit/ImageKit";
import { ImageKitUpload } from "../../../middlewares/libraries/imageKit/ImageKitLibrary";
import ModalDetails from "../utils/hotelRestauDetails/ModalDetails";
import ExteriorImages from "./exteriorImages";
import { useGeoPositionContext } from "../utils/geoPosition";
import { _TYPES_ } from "../utils/types";
import Pricing from "../../home/component/Pricing";
import GenerateDescription from "../utils/GenerateDescription";

const Edit = () => {
  const { updateOneContent } = useDoSeeDataContext();
  const hotel = getOneHotel();
  const {
    country_id,
    entry_label,
    country_name,
    first_level_id,
    fourth_level_id,
    second_level_id,
    third_level_id,
  } = useGeoPositionContext();

  const [error, setError] = useState(false);
  const [message, setErrorMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const hotel_id = hotel?.hotel_id;
  const [title, setTitle] = useState(hotel?.title);
  const [thumbnail, setThumbnail] = useState(hotel?.thumbnail);
  const [thumbnailId, setThumbnailId] = useState(hotel?.image_cdn_id);
  const [venue, setVenue] = useState(hotel?.venue);
  const [rating, setRating] = useState(hotel?.rating);
  const [email, setEmail] = useState(hotel?.email_address);
  const [payLink, setPayLink] = useState(hotel?.pay_link);
  const [phoneNumber, setPhoneNumber] = useState(hotel?.phone_number);
  const [whatsapp, setWhatsapp] = useState(hotel?.whatsapp);
  const [facebook, setFacebook] = useState(hotel?.facebook);
  const [twitter, setTwitter] = useState(hotel?.twitter);
  const [instagram, setInstagram] = useState(hotel?.instagram);
  const [youtube, setYoutube] = useState(hotel?.youtube);
  const [hashtags, setHashtags] = useState(hotel?.hashtag);
  const [googleMapCode, setGoogleMapCode] = useState(hotel?.google_map_code);
  const [latitude, setLatitude] = useState(hotel?.latitude);
  const [longitude, setLongitude] = useState(hotel?.longitude);
  const [formattedAddress, setFormattedAddress] = useState(
    hotel?.formatted_address
  );
  const [featured, setFeatured] = useState(hotel?.featured);
  const [promoted, setPromoted] = useState(
    hotel?.promoted ? hotel?.promoted : "no"
  );
  const [hotelStatus, setHotelStatus] = useState(hotel?.status);
  const [description, setDescription] = useState(hotel?.description);
  const [collection, setCollection] = useState(
    hotel?.HotelRestauDescriptions ? hotel?.HotelRestauDescriptions : []
  );
  const [expo, setExpo] = useState(hotel?.expo);
  const [showTop, setShowTop] = useState(hotel?.show_top);
  const [exteriorImages, setExteriorImages] = useState(hotel?.exterior_images);
  const [pricing, setPricing] = useState(hotel?.Pricings);

  const [showModal, setShowModal] = useState(false);
  const [showExtImages, setShowExtImages] = useState(false);
  const [showDescriptionModal, setShowDescriptionModal] = useState(null);

  const hotelRoutes = "/data/hotel";

  const responses = (isError, message) => {
    setError(isError);
    setLoading(false);
    setSuccess(!isError);
    setErrorMessage(message);
  };

  const updateOneHotelHandler = async (e) => {
    e.preventDefault();
    setLoading(true);
    if (!thumbnail || !thumbnailId) {
      responses(true, "Image Required");
    } else {
      await sendDBRequest();
    }
  };

  /**
   * @author Ntavigwa Bashombe
   * @param {*} thumbnail
   * @returns
   */
  const sendDBRequest = async () => {
    const data = {
      country_id: country_id ? country_id : hotel?.country_id,
      first_level_id: first_level_id ? first_level_id : 0,
      second_level_id: second_level_id ? second_level_id : 0,
      third_level_id: third_level_id ? third_level_id : 0,
      fourth_level_id: fourth_level_id ? fourth_level_id : 0,
      title: title,
      slug: title ? title.toLowerCase().replace(/\s/g, "_") : null,
      description: description,
      venue: venue,
      rating: rating,
      thumbnail: thumbnail ? thumbnail : defaultImage,
      image_cdn_id: thumbnailId ? thumbnailId : "",
      phone_number: phoneNumber,
      email_address: email,
      pay_link: payLink,
      whatsapp: whatsapp,
      facebook: facebook,
      twitter: twitter,
      instagram: instagram,
      youtube: youtube,
      hashtag: hashtags,
      audio_adv: "none",
      google_map_code: googleMapCode,
      latitude: latitude,
      longitude: longitude,
      formatted_address: formattedAddress,
      country_short: "none",
      status: hotelStatus,
      featured: featured,
      promoted: promoted,
      subdata: collection?.length > 0 ? collection : [],
      expo: expo,
      show_top: showTop,
      exterior_images: exteriorImages?.filter((x) => x?.thumbnail !== null),
      pricing: pricing,
    };

    const { message, status } = await updateOneContent({
      data_id: hotel_id,
      data: data,
      content: _TYPES_.HOTEL,
      position: {
        country_id,
        first_level_id,
        second_level_id,
        third_level_id,
        fourth_level_id,
      },
    });

    if (status === codeOk) responses(false, message);
    else responses(true, message);
  };

  return (
    <div className="p-4 lg:p-6 h-full overflow-y-auto bg-gray-50">
      {/* Header */}
      <div className="max-w-6xl mx-auto">
        <BreadCrumbComponent />
        <div className="flex items-center justify-between mt-2">
          <GoBack props={{ route: hotelRoutes }} />
          <div className="text-xs text-gray-500 truncate">
            Editing:{" "}
            <span className="font-medium text-gray-700">
              {title || hotel?.title || "Untitled"}
            </span>
          </div>
        </div>

        {showDescriptionModal ? (
          <GenerateDescription
            setDescription={setDescription}
            setShowDescriptionModal={setShowDescriptionModal}
          />
        ) : null}

        <div className="my-4">
          <DashboardIntro props={{ intro: `Edit Hotel`, name: entry_label }} />
        </div>

        {/* Alerts */}
        <MyMessage
          error={error}
          message={message}
          success={success}
          onExpired={() => {
            setError(false);
            setSuccess(false);
          }}
          onClick={() => {
            setError(false);
            setSuccess(false);
            setErrorMessage("");
          }}
        />
      </div>

      {/* Form */}
      <form
        onSubmit={updateOneHotelHandler}
        className="max-w-6xl mx-auto space-y-6"
      >
        {/* Media */}
        <section className="bg-white border border-gray-200 rounded-2xl shadow-sm p-4">
          <div className="flex items-center justify-between">
            <Title props={{ title: "Cover Image" }} />
            <span className="text-xs text-gray-500">Recommended: JPG/PNG</span>
          </div>
          <div className="mt-3">
            <ImageKitUpload
              thumbnail={thumbnail}
              thumbnailId={thumbnailId}
              setThumbnail={setThumbnail}
              setThumbnailId={setThumbnailId}
              folder={image_kit_folder(country_name, FOLDERS.HOTELS)}
            />
          </div>
        </section>

        {/* Hotel Details */}
        <section className="bg-white border border-gray-200 rounded-2xl shadow-sm p-4">
          <Title props={{ title: "Hotel Details" }} />
          <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4 w-full">
            <InputField
              props={{
                id: "title",
                title: "Title",
                type: "text",
                value: title ? title : "",
                placeholder: "e.g., LakeView Resort & Spa",
                onChange: (e) => {
                  setTitle(e.target.value);
                  setError(null);
                  setSuccess(null);
                },
              }}
            />
            <Select
              props={{
                id: "top",
                title: "Show In Top Hotels",
                option: ["no", "yes"],
                preselect:
                  showTop !== null
                    ? [{ name: showTop === 0 ? "no" : "yes" }]
                    : null,
                onChange: (e) => {
                  if (e.target.selectedIndex === 0) setShowTop(0);
                  else setShowTop(1);
                  setError(null);
                  setSuccess(null);
                },
              }}
            />
            <InputField
              props={{
                id: "venue",
                title: "Venue",
                type: "text",
                value: venue ? venue : "",
                placeholder: "Neighborhood / Area",
                onChange: (e) => {
                  setVenue(e.target.value);
                  setError(null);
                  setSuccess(null);
                },
              }}
            />

            <InputField
              props={{
                id: "formatted_address",
                title: "Formatted Address",
                type: "address",
                value: formattedAddress ? formattedAddress : "",
                placeholder: "Street, City, Region",
                onChange: (e) => {
                  setFormattedAddress(e.target.value);
                  setError(null);
                  setSuccess(null);
                },
              }}
            />
            <InputField
              props={{
                id: "rating",
                title: "Rating",
                type: "text",
                value: rating ? rating : "",
                placeholder: "e.g., 4.5",
                onChange: (e) => {
                  setRating(e.target.value);
                  setError(null);
                  setSuccess(null);
                },
              }}
            />
          </div>
        </section>

        {/* Pricing */}
        <section className="bg-white border border-gray-200 rounded-2xl shadow-sm p-4">
          <Title props={{ title: "Pricing" }} />
          <Pricing pricing={pricing} setPricing={setPricing} />
        </section>

        {/* Contact Info */}
        <section className="bg-white border border-gray-200 rounded-2xl shadow-sm p-4">
          <Title props={{ title: "Contact Info" }} />
          <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4 w-full">
            <div className="flex flex-row justify-center items-center">
              <PhoneInput
                setPhone={setPhoneNumber}
                phone={phoneNumber}
                required={false}
              />
            </div>
            <InputField
              props={{
                id: "email",
                title: "Email Address",
                type: "email",
                value: email ? email : "",
                placeholder: "info@hotel.com",
                onChange: (e) => {
                  setEmail(e.target.value);
                  setError(null);
                  setSuccess(null);
                },
              }}
            />
            <InputField
              props={{
                id: "pay-link",
                title: "Pay Link (Optional)",
                type: "text",
                value: payLink ? payLink : null,
                onChange: (e) => {
                  setPayLink(e.target.value);
                  setError(null);
                  setSuccess(null);
                },
              }}
            />
          </div>
        </section>

        {/* Social Contact */}
        <section className="bg-white border border-gray-200 rounded-2xl shadow-sm p-4">
          <Title props={{ title: "Social Contact" }} />
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 w-full">
            <InputField
              props={{
                id: "whatsapp",
                title: "Whatsapp",
                type: "text",
                value: whatsapp ? whatsapp : "",
                onChange: (e) => {
                  setWhatsapp(e.target.value);
                  setError(null);
                  setSuccess(null);
                },
              }}
            />
            <InputField
              props={{
                id: "facebook",
                title: "Facebook",
                type: "text",
                value: facebook ? facebook : "",
                onChange: (e) => {
                  setFacebook(e.target.value);
                  setError(null);
                  setSuccess(null);
                },
              }}
            />
            <InputField
              props={{
                id: "twitter",
                title: "Twitter",
                type: "text",
                value: twitter ? twitter : "",
                onChange: (e) => {
                  setTwitter(e.target.value);
                  setError(null);
                  setSuccess(null);
                },
              }}
            />
            <InputField
              props={{
                id: "instagram",
                title: "Instagram",
                type: "text",
                value: instagram ? instagram : "",
                onChange: (e) => {
                  setInstagram(e.target.value);
                  setError(null);
                  setSuccess(null);
                },
              }}
            />
            <InputField
              props={{
                id: "youtube",
                title: "YouTube",
                type: "text",
                value: youtube ? youtube : "",
                onChange: (e) => {
                  setYoutube(e.target.value);
                  setError(null);
                  setSuccess(null);
                },
              }}
            />
          </div>
        </section>

        {/* Geo Position */}
        <section className="bg-white border border-gray-200 rounded-2xl shadow-sm p-4">
          <Title props={{ title: "Geo Position" }} />
          <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-4 w-full">
            <InputField
              props={{
                id: "google_map_code",
                title: "Google Map Code",
                type: "text",
                value: googleMapCode ? googleMapCode : "",
                onChange: (e) => {
                  setGoogleMapCode(e.target.value);
                  setError(null);
                  setSuccess(null);
                },
              }}
            />
            <InputField
              props={{
                id: "latitude",
                title: "Latitude",
                type: "text",
                value: latitude ? latitude : "",
                onChange: (e) => {
                  setLatitude(e.target.value);
                  setError(null);
                  setSuccess(null);
                },
              }}
            />
            <InputField
              props={{
                id: "longitude",
                title: "Longitude",
                type: "text",
                value: longitude ? longitude : "",
                onChange: (e) => {
                  setLongitude(e.target.value);
                  setError(null);
                  setSuccess(null);
                },
              }}
            />
          </div>
        </section>

        {/* More Settings */}
        <section className="bg-white border border-gray-200 rounded-2xl shadow-sm p-4">
          <Title props={{ title: "More Settings" }} />
          <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4 w-full">
            <Select
              props={{
                id: "hotel_status",
                title: "Status",
                option: ["visible", "invisible"],
                preselect:
                  hotelStatus !== null
                    ? [{ name: hotelStatus === 1 ? "visible" : "invisible" }]
                    : null,
                onChange: (e) => {
                  if (e.target.selectedIndex === 0) setHotelStatus(1);
                  else setHotelStatus(0);

                  setError(null);
                  setSuccess(null);
                },
              }}
            />
            <Select
              props={{
                id: "featured",
                title: "Featured",
                option: ["no", "yes"],
                preselect: featured !== null ? [{ name: featured }] : null,
                onChange: (e) => {
                  setFeatured(e.target.value);
                  setError(null);
                  setSuccess(null);
                },
              }}
            />
            <Select
              props={{
                id: "promoted",
                title: "Promoted",
                option: ["no", "yes"],
                preselect: promoted !== null ? [{ name: promoted }] : null,
                onChange: (e) => {
                  setPromoted(e.target.value);
                  setError(null);
                  setSuccess(null);
                },
              }}
            />
            <Select
              props={{
                id: "gallery",
                title: "Show in Gallery",
                option: ["no", "yes"],
                preselect:
                  expo !== null ? [{ name: expo === 0 ? "no" : "yes" }] : null,
                onChange: (e) => {
                  const choice = e.target.value;
                  setExpo(choice === "no" ? 0 : 1);
                  setError(null);
                  setSuccess(null);
                },
              }}
            />
          </div>
        </section>

        {/* Description & Tags */}
        <section className="bg-white border border-gray-200 rounded-2xl shadow-sm p-4">
          <div className="flex items-center justify-between">
            <Title props={{ title: "Description" }} />
            <MyButton
              onClick={() => setShowDescriptionModal(true)}
              className="bg-blue-700 py-2 px-4 rounded-lg text-white"
            >
              Generate Description
            </MyButton>
          </div>
          <TextArea
            props={{
              id: "description",
              title: "Description",
              type: "text",
              value: description ? description : "",
              onChange: (e) => {
                setDescription(e.target.value);
                setError(null);
                setSuccess(null);
              },
            }}
          />
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 w-full pt-4">
            <InputField
              props={{
                id: "hashtag",
                title: "Tags (comma separated)",
                type: "text",
                value: hashtags ? hashtags : "",
                onChange: (e) => {
                  setHashtags(e.target.value);
                  setError(null);
                  setSuccess(null);
                },
              }}
            />
          </div>
        </section>

        {/* Galleries & Extras */}
        <section className="bg-white border border-gray-200 rounded-2xl shadow-sm p-4">
          <Title props={{ title: "Galleries & Extras" }} />
          <div className="w-full flex flex-wrap gap-3 items-center pt-2">
            <Button
              props={{
                type: "button",
                title: "Change Inter. / Exter. Images",
                category: "default",
                action: "edit",
                onClick: () => setShowExtImages(true),
              }}
            />
            <Button
              props={{
                type: "button",
                title: "Change More Details",
                category: "default",
                action: "edit",
                onClick: () => setShowModal(true),
              }}
            />
          </div>
        </section>

        {/* Sticky Footer Actions */}
        <div className="sticky bottom-0 z-10 bg-gray-50/90 backdrop-blur border-t border-gray-200 py-3">
          <div className="max-w-6xl mx-auto flex items-center justify-between">
            <div className="text-xs text-gray-500">
              Make sure to save your changes
            </div>
            <MyActionButton
              loading={loading}
              title="Save Changes"
              onClick={() => {
                setError(false);
                setSuccess(false);
                setErrorMessage(null);
              }}
            />
          </div>
        </div>
      </form>

      {/* Modals */}
      <div className="max-w-6xl mx-auto">
        <ModalDetails
          onClick={() => setShowModal(false)}
          showModal={showModal}
          collection={collection}
          setCollection={setCollection}
        />

        <ExteriorImages
          exteriorImages={exteriorImages}
          setExteriorImages={setExteriorImages}
          showModal={showExtImages}
          onClick={() => setShowExtImages(false)}
        />
      </div>
    </div>
  );
};

export default Edit;
